import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Box, Typography, Button } from "@mui/material";
import { BasicModal } from "../BasicModal/BasicModal";

const EditTextModal = ({
	showModal,
	handleClose,
	value,
	onChange,
	onSave,
	width = 600,
}) => {
	return (
		<BasicModal
			width={width}
			showModal={showModal}
			handleClose={handleClose}
			hideClose
			children={
				<Box sx={{ padding: { xs: 2, sm: 3 } }}>
					<Typography
						variant="h5"
						sx={{
							fontWeight: 700,
							color: "#1a1a2e",
							mb: 1,
							fontSize: { xs: "1.25rem", sm: "1.5rem" },
						}}
					>
						Edita el texto
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: "#4B5563",
							fontSize: { xs: "0.875rem", sm: "0.95rem" },
							mb: 2,
						}}
					>
						Modifica el contenido de este bloque
					</Typography>
					<Box
						sx={{
							"& .ql-container": {
								fontSize: { xs: "14px", sm: "16px" },
								borderRadius: "0 0 12px 12px",
							},
							"& .ql-toolbar": {
								borderRadius: "12px 12px 0 0",
								borderColor: "rgba(0, 0, 0, 0.12)",
							},
							"& .ql-container": {
								borderColor: "rgba(0, 0, 0, 0.12)",
							},
							"& .ql-editor": {
								minHeight: 160,
							},
						}}
					>
						<ReactQuill
							theme="snow"
							value={value}
							onChange={onChange}
							modules={{
								clipboard: {
									matchVisual: false,
								},
							}}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: { xs: "column-reverse", sm: "row" },
							mt: 3,
							gap: 1.5,
							justifyContent: { xs: "stretch", sm: "flex-end" },
						}}
					>
						<Button
							onClick={handleClose}
							variant="outlined"
							sx={{
								width: { xs: "100%", sm: "auto" },
								fontSize: { xs: "0.875rem", sm: "1rem" },
								fontWeight: 600,
								textTransform: "none",
								borderRadius: "12px",
								borderColor: "rgba(0, 0, 0, 0.12)",
								color: "#1a1a2e",
								"&:hover": {
									borderColor: "#6366F1",
									backgroundColor: "rgba(99, 102, 241, 0.04)",
								},
							}}
						>
							Cancelar
						</Button>
						<Button
							variant="contained"
							onClick={onSave}
							sx={{
								width: { xs: "100%", sm: "auto" },
								fontSize: { xs: "0.875rem", sm: "1rem" },
								fontWeight: 600,
								textTransform: "none",
								borderRadius: "12px",
								background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
								boxShadow: "0 4px 16px rgba(99, 102, 241, 0.35)",
								"&:hover": {
									background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
									boxShadow: "0 6px 20px rgba(99, 102, 241, 0.45)",
									transform: "translateY(-2px)",
								},
							}}
						>
							Guardar
						</Button>
					</Box>
				</Box>
			}
		/>
	);
};

export default EditTextModal;
